var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMightydigitsLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.487 22.981a10.416 10.416 0 0 1-8.114-3.887 10.477 10.477 0 0 1-2.088-8.77v-.586l.104.14 3.366 4.617h.405l3.547-4.743v7.927h2.05V6.752H9.41l-3.41 4.702-2.754-3.797-.653-.905h-1.19a12.545 12.545 0 0 0-.853 9.435 12.509 12.509 0 0 0 5.984 7.331 12.455 12.455 0 0 0 9.394 1.028 12.49 12.49 0 0 0 7.421-5.864H20.91a10.435 10.435 0 0 1-3.698 3.161 10.407 10.407 0 0 1-4.725 1.138z",
    fill: "#85B440"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.876 10.96a12.527 12.527 0 0 0-3.08-6.786A12.475 12.475 0 0 0 15.414.348a12.451 12.451 0 0 0-7.42.493A12.487 12.487 0 0 0 2.168 5.48h2.603a10.435 10.435 0 0 1 5-3.056 10.414 10.414 0 0 1 5.854.124c1.9.6 3.59 1.733 4.868 3.264a10.48 10.48 0 0 1 2.348 5.379 4.41 4.41 0 0 1 .078 1.63c-.21 1.514-1.232 2.862-3.367 2.862H17.31V8.687h2.242a3.58 3.58 0 0 1 1.864.467c-.193-1.215-.64-1.958-.952-2.358a7.048 7.048 0 0 0-.912-.06h-4.28v10.929h4.28c.758.01 1.513-.12 2.225-.382 1.988-.757 3.006-2.54 3.19-4.428a6.448 6.448 0 0 0-.092-1.894z",
    fill: "#32324D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m38.172 10.435-3.06 4.079h-.348L31.77 10.42v6.829H30V7.86h2.04l2.938 4.037 2.94-4.037h2.025v9.39h-1.771v-6.815z",
    fill: "#85B440"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.377 7.846H41.62v9.39h1.758v-9.39z",
    fill: "#85B440"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.018 10.14a3.599 3.599 0 0 0-2.388-.939c-2.013 0-3.235 1.53-3.235 3.461 0 1.537.9 3.139 3.235 3.139a3.126 3.126 0 0 0 2.12-.75v-1.665H49.35v-1.583h4.025v3.957c-.926 1.06-2.096 1.69-3.744 1.69-3.53 0-4.965-2.32-4.965-4.787 0-2.644 1.65-5.081 4.965-5.081 1.308 0 2.564.515 3.494 1.435l-1.106 1.123zM61.223 17.25v-3.797h-4.617v3.797h-1.771V7.86h1.771v3.957h4.617V7.86h1.757v9.39h-1.757zM67.072 9.456h-2.98v-1.61h7.73v1.61h-2.978v7.78h-1.772v-7.78z",
    fill: "#85B440"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m77.417 11.724 2.496-3.878h2.133v.081l-3.743 5.433v3.876h-1.772V13.36l-3.61-5.433v-.08h2.107l2.389 3.877z",
    fill: "#85B440",
    stroke: "#85B440",
    strokeWidth: 0.57,
    strokeMiterlimit: 22.93
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8 12.461c.04 2.376-1.41 4.775-4.698 4.775h-3.69v-9.39h3.69c3.222 0 4.658 2.294 4.698 4.611v.004zm-6.627 3.072h1.93c2.134 0 2.98-1.557 2.935-3.086-.04-1.461-.9-2.924-2.936-2.924h-1.929v6.01z",
    fill: "#32324D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.885 7.846h-1.758v9.39h1.758v-9.39z",
    fill: "#32324D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.525 10.14a3.597 3.597 0 0 0-2.387-.939c-2.013 0-3.235 1.53-3.235 3.461 0 1.537.899 3.139 3.235 3.139a3.123 3.123 0 0 0 2.119-.75v-1.665h-2.401v-1.583h4.027v3.957c-.926 1.06-2.097 1.69-3.744 1.69-3.53 0-4.966-2.32-4.966-4.787 0-2.644 1.65-5.085 4.966-5.085 1.309 0 2.565.515 3.495 1.435l-1.109 1.127z",
    fill: "#32324D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.1 7.846h-1.758v9.39h1.758v-9.39z",
    fill: "#32324D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.622 9.456h-2.98v-1.61h7.729v1.61h-2.984v7.78h-1.765v-7.78zM126.242 10.114c-.323-.537-1.207-1.047-2.228-1.047-1.315 0-1.946.55-1.946 1.248 0 .817.966 1.045 2.097 1.18 1.957.241 3.784.751 3.784 2.99 0 2.097-1.852 2.992-3.946 2.992-1.918 0-3.395-.59-4.093-2.306l1.476-.765c.42 1.033 1.504 1.488 2.645 1.488 1.118 0 2.16-.388 2.16-1.408 0-.885-.926-1.248-2.174-1.38-1.919-.23-3.69-.74-3.69-2.845 0-1.932 1.905-2.724 3.634-2.736 1.462 0 2.979.419 3.69 1.864l-1.409.725z",
    fill: "#32324D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMightydigitsLogoLight);
export default __webpack_public_path__ + "static/media/mightydigits-logo-light.82c229615623039f9dd5993f9ee08dc0.svg";
export { ForwardRef as ReactComponent };